import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  NativeSelect,
  Select,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetSpecificCompanyPropertyByIdQuery } from "../../services/users";
import { errorToast, successToast } from "../../helpers/toast";
import {
  useDeleteByIdPropertyMutation,
  useLazyGetPropertiesForCompanyQuery,
  useLazyGetpropertYTypeListingQuery,
} from "../../services/property";
import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import Loader from "../../helpers/constants/Loader";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import { useLazyGetAllActionTrackerByCompanyQuery } from "../../services/actionTracker";
import { OFFER_STATUS, ROLE } from "../../constants/enums";
import CategorySelector from "../../components/CategorySelector";
import { useLazyGetAllCategoryQuery } from "../../services/category";
import moment from "moment";
import QualityCriteria from "../../components/QualityScoreModal";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
type Criteria = {
  complete: string[];
  incomplete: string[];
};
const AgentPropertiesDetails = () => {
  const { _id } = useParams();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [deletePropertyById] = useDeleteByIdPropertyMutation();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [listingType, setListingType] = useState<number | string>("");
  const [allDetailsById, setAllDetailsById] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedParentCategory, setSelectedParentCategory] = useState<any>("");
  const [visibleName, setVisibleName] = useState("Select category");
  const [agencyType, setAgencyType] = useState<any>("");
  const [propertyTypeList] = useLazyGetpropertYTypeListingQuery();
  const [fetchAllCategory] = useLazyGetAllCategoryQuery();
  const [properties, setProperties] = useState<{ _id: string; name: string }[]>(
    []
  );
  const [isRent, setIsRent] = useState<boolean>(false);
  const [isBuy, setIsBuy] = useState<boolean>(false);
  const [propertyType, setPropertyType] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [categoryDataNew, setCategoryDataNew] = useState<any>([]);
  const [openCriteria, setOpenCriteria] = useState<boolean>(false);
  const onCloseCriteria = () => {
    setOpenCriteria(false);
  };
  const [qualityScoreData, setQualityScoreData] = useState<Criteria>({
    complete: [],
    incomplete: [],
  });
  const handleCategoryReset = () => {
    setSelectedParentCategory("");
    setCategory("");
  };
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [limit, setLimit] = useState<number>(10);

  let totalPages = Math.ceil(totalCount / limit);
  const [page, setPage] = useState(1);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setAllDetailsById([]);
  };
  const [selectedId, setSelectedId] = useState<number>(0);
  const [AllDetails] = useLazyGetPropertiesForCompanyQuery();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataCount, setDataCount] = useState({
    publishedRequests: 0, //published
    underOfferRequests: 0, //under offer
    unpublishedRequests: 0, //claimed
    temporaryUnpublish: 0, //unpublished
    xmlUnpublisheProperties: 0, // temporary unpublished
  });

  function formatNumberWithCommas(value: string | number) {
    const valueStr = typeof value === "number" ? value.toFixed(2) : value;
    const [integer, decimal] = valueStr.split(".");
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let result =
      decimal !== undefined
        ? `${formattedInteger}.${decimal}`
        : formattedInteger;
    return result;
  }

  const fetchAllDataById = async () => {
    setIsLoading(true);
    try {
      const response = await AllDetails({
        userId: _id,
        page: page,
        search: debouncedSearchTerm,
        limit: limit,
        propertyTypeId: isBuy || isRent ? "" : propertyType,
        categoryId: category,
        categoryParentId: selectedParentCategory,
        listingType: Number(listingType) || "",
        agencyType: agencyType,
        offerStatus:
          value === 0
            ? OFFER_STATUS.PUBLISHED
            : value === 1
              ? OFFER_STATUS.UNDER_OFFER
              : value === 2
                ? OFFER_STATUS.CLAIMED
                : value === 3
                  ? OFFER_STATUS.UNPUBLISHED
                  : value === 4
                    ? OFFER_STATUS.TEMPORARY_UNPUBLISHED
                    : 0,
        // isClaimDocStatus: value === 2 ? 2 : null,
        isPublish: value === 2 ? "false" : null,
        isBuy: isBuy,
        isRent: isRent,
      }).unwrap();
      if (response.statusCode === 200) {
        setAllDetailsById(response?.data?.property || []);
        setTotalCount(response?.data?.count || 0);
        setDataCount({
          publishedRequests: response?.data?.publishedRequests || 0,
          underOfferRequests: response?.data?.underOfferRequests || 0,
          unpublishedRequests: response?.data?.unpublishedRequests || 0,
          temporaryUnpublish: response?.data?.temporaryUnpublish || 0,
          xmlUnpublisheProperties: response?.data?.xmlUnpublisheProperties || 0,
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await fetchAllCategory({
        type: "both",
      }).unwrap();
      if (response?.statusCode === 200) {
        const data = response?.data.map((item: any) => {
          return {
            categoryName: item._id,
            subCategory: {
              [item._id._id]: item.categories,
            },
          };
        });
        setCategoryDataNew(data);
      }
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const fetchPropertyType = async () => {
    try {
      const response = await propertyTypeList({}).unwrap();
      if (response?.statusCode === 200) {
        setProperties(response?.data?.propertyType || []);
      }
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const handleDeleteProperty = async (userId: any) => {
    setIsLoading(true);
    try {
      const response = await deletePropertyById({ userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Property deleted successfully");
        fetchAllDataById();
      }
      setIsLoading(false);
    } catch (error: any) {
      console.error(error);
      setIsLoading(false);
      errorToast(error?.message || error?.data?.message);
    }
  };

  useEffect(() => {
    fetchPropertyType();
    fetchCategories();
  }, []);

  useEffect(() => {
    if (_id) {
      fetchAllDataById();
    }
  }, [
    value,
    page,
    limit,
    debouncedSearchTerm,
    agencyType,
    propertyType,
    category,
    listingType,
    selectedParentCategory,
  ]);

  return (
    <>
      <Box className="custom_tabs">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab
            label={`Published (${dataCount?.publishedRequests})`}
            {...a11yProps(0)}
          />
          <Tab
            label={`Under Offer (${dataCount?.underOfferRequests})`}
            {...a11yProps(1)}
          />

          <Tab
            label={`Claimed (${dataCount?.unpublishedRequests})`}
            {...a11yProps(2)}
          />

          <Tab
            label={`Unpublished (${dataCount?.temporaryUnpublish})`}
            {...a11yProps(3)}
          />
          <Tab
            label={`Temporary Unpublished (${dataCount?.xmlUnpublisheProperties})`}
            {...a11yProps(4)}
          />
        </Tabs>
      </Box>
      <Box className="cards_header" style={{ marginBottom: "10px" }}>
        <SearchBar2
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(val: any) => {
            if (isValidInput(val.target.value)) {
              setSearchTerm(val.target.value);
              setTimeout(() => {
                setPage(1);
              }, 1000);
            }
          }}
        />
      </Box>
      <div className="Filters_div mb_20">
        <div className="childFilter childfilter1">
          <Select
            className="select_div"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={propertyType}
            // onChange={(e) => setPropertyType(e.target.value)}
            onChange={(e) => {
              const selectedProperty = properties?.find(
                (it: any) => it?._id === e.target.value
              );

              if (selectedProperty?.name === "Rent") {
                setIsRent(true);
                setIsBuy(false);
                setPropertyType(e.target.value);
              } else if (selectedProperty?.name === "Buy") {
                setIsBuy(true);
                setIsRent(false);
                setPropertyType(e.target.value);
              } else {
                setPropertyType(e.target.value);
                setIsRent(false);
                setIsBuy(false);
              }
            }}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select Property Type
            </MenuItem>
            {properties?.length > 0
              ? properties?.map((it: any) => (
                  <MenuItem key={it?._id} value={it?._id}>
                    {it?.name}
                  </MenuItem>
                ))
              : ""}
          </Select>
        </div>
        <div className="childFilter ">
          <CategorySelector
            categoryData={categoryDataNew}
            handleReset={handleCategoryReset}
            category={category}
            parentCategory={selectedParentCategory}
            setCategory={setCategory}
            visibleName={visibleName}
            setVisibleName={setVisibleName}
            setParentCategory={setSelectedParentCategory}
          />
        </div>
        <div className="childFilter childfilter1">
          <Select
            className="select_div"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={listingType}
            onChange={(e) => setListingType(Number(e.target.value))}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select Listing
            </MenuItem>

            <MenuItem value="1">Standard </MenuItem>
            <MenuItem value="3">Premium</MenuItem>
            <MenuItem value="2">Featured</MenuItem>
          </Select>
        </div>
        <div className="childFilter childfilter1">
          <Select
            value={agencyType}
            onChange={(e) => setAgencyType(e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select company type
            </MenuItem>
            <MenuItem value="1">Real estate broker</MenuItem>
            <MenuItem value="2">Short-term rentals</MenuItem>
          </Select>
        </div>
        {propertyType !== "" ||
        category !== "" ||
        selectedParentCategory !== "" ||
        listingType !== "" ||
        isBuy ||
        isRent ||
        agencyType !== "" ? (
          <Button
            className="btn btn_primary mt_20"
            onClick={() => {
              setPropertyType("");
              setCategory("");
              setAgencyType("");
              setListingType("");
              setVisibleName("Select category");
              setSelectedParentCategory("");
              setIsBuy(false);
              setIsRent(false);
            }}
          >
            Clear filters
          </Button>
        ) : (
          ""
        )}
      </div>
      <CustomTabPanel value={value} index={0}>
        <Card className="cards">
          <Loader isLoad={isLoading} />
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Actions</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Property Id</TableCell>
                  <TableCell>Reference No.</TableCell>
                  <TableCell>Permit Number</TableCell>
                  <TableCell>Badges</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Quality Score</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Property Status</TableCell>
                  <TableCell>Company Name</TableCell>
                  <TableCell>Property Type</TableCell>
                  <TableCell>Expiry Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allDetailsById.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No property found
                    </TableCell>
                  </TableRow>
                ) : (
                  allDetailsById.map((property: any, index: number) => (
                    <TableRow key={property?._id}>
                      <TableCell align="center">
                        {" "}
                        {(page - 1) * 10 + index + 1}
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton
                            onClick={() =>
                              navigate(
                                `/manage-agents/property-listing/details/${property?._id}/${_id}`
                              )
                            }
                          >
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(property?._id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <figure className="user_img">
                          <img
                            style={{ borderRadius: 0 }}
                            src={
                              property?.images?.[0] ||
                              "/static/images/product1.png"
                            }
                            alt=""
                          />
                        </figure>
                      </TableCell>
                      <TableCell>{property?.referenceId || "-"}</TableCell>
                      <TableCell>
                        {property?.import_reference_number || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.advertisementPermitNo || "-"}
                      </TableCell>

                      <TableCell align="center">
                        <figure className="user_img">
                          {property?.properties?.isVerified ? (
                            <img
                              className="property_badge"
                              src="/static/images/verfy_icon.svg"
                              alt=""
                            />
                          ) : (
                            ""
                          )}
                          {property?.properties?.qualityScore >= 80 ? (
                            <img src="/static/images/verify_ico.svg" alt="" />
                          ) : (
                            ""
                          )}
                          {property?.properties?.isPropertyBoost ? (
                            <img src="/static/images/boost.png" alt="" />
                          ) : (
                            ""
                          )}
                        </figure>
                      </TableCell>
                      <TableCell>{property?.name || "-"}</TableCell>
                      <TableCell>
                        {property?.price
                          ? formatNumberWithCommas(property?.price)
                          : "-"}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (property?.qualityScoreMeetCriteria?.length) {
                            setQualityScoreData({
                              complete:
                                property?.qualityScoreMeetCriteria || [],
                              incomplete:
                                property?.qualityScorePendingCriteria || [],
                            });
                            setOpenCriteria(true);
                          }
                        }}
                      >
                        {property?.qualityScore || "-"}
                      </TableCell>
                      <TableCell>{property?.address || "-"}</TableCell>
                      <TableCell>
                        {property?.propertyStatus === 1
                          ? "Rented"
                          : property?.propertyStatus === 2
                            ? "Sold"
                            : "Live"}
                      </TableCell>

                      <TableCell>
                        {property?.companyId?.companyName
                          ? property?.companyId?.companyName +
                            " (" +
                            property?.companyId?.referenceId +
                            ")"
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyTypes?.name || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyEndDate
                          ? moment(property?.propertyEndDate).format("LLL")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
        {allDetailsById?.length > 0 ? (
          <Pagination
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            module={allDetailsById}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Card className="cards">
          <Loader isLoad={isLoading} />
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Actions</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Property Id</TableCell>
                  <TableCell>Reference No.</TableCell>
                  <TableCell>Permit Number</TableCell>
                  <TableCell>Badges</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Quality Score</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Property Status</TableCell>
                  <TableCell>Company Name</TableCell>
                  <TableCell>Property Type</TableCell>
                  <TableCell>Expiry Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allDetailsById.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No property found
                    </TableCell>
                  </TableRow>
                ) : (
                  allDetailsById.map((property: any, index: number) => (
                    <TableRow key={property?._id}>
                      <TableCell align="center">
                        {" "}
                        {(page - 1) * 10 + index + 1}
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton
                            onClick={() =>
                              navigate(
                                `/manage-agents/property-listing/details/${property?._id}/${_id}`
                              )
                            }
                          >
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(property?._id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <figure className="user_img">
                          <img
                            style={{ borderRadius: 0 }}
                            src={
                              property?.images?.[0] ||
                              "/static/images/product1.png"
                            }
                            alt=""
                          />
                        </figure>
                      </TableCell>
                      <TableCell>{property?.referenceId || "-"}</TableCell>
                      <TableCell>
                        {property?.import_reference_number || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.advertisementPermitNo || "-"}
                      </TableCell>

                      <TableCell align="center">
                        <figure className="user_img">
                          {property?.properties?.isVerified ? (
                            <img
                              className="property_badge"
                              src="/static/images/verfy_icon.svg"
                              alt=""
                            />
                          ) : (
                            ""
                          )}
                          {property?.properties?.qualityScore >= 80 ? (
                            <img src="/static/images/verify_ico.svg" alt="" />
                          ) : (
                            ""
                          )}
                          {property?.properties?.isPropertyBoost ? (
                            <img src="/static/images/boost.png" alt="" />
                          ) : (
                            ""
                          )}
                        </figure>
                      </TableCell>
                      <TableCell>{property?.name || "-"}</TableCell>
                      <TableCell>
                        {property?.price
                          ? formatNumberWithCommas(property?.price)
                          : "-"}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (property?.qualityScoreMeetCriteria?.length) {
                            setQualityScoreData({
                              complete:
                                property?.qualityScoreMeetCriteria || [],
                              incomplete:
                                property?.qualityScorePendingCriteria || [],
                            });
                            setOpenCriteria(true);
                          }
                        }}
                      >
                        {property?.qualityScore || "-"}
                      </TableCell>
                      <TableCell>{property?.address || "-"}</TableCell>
                      <TableCell>
                        {property?.propertyStatus === 1
                          ? "Rented"
                          : property?.propertyStatus === 2
                            ? "Sold"
                            : "Live"}
                      </TableCell>

                      <TableCell>
                        {property?.companyId?.companyName
                          ? property?.companyId?.companyName +
                            " (" +
                            property?.companyId?.referenceId +
                            ")"
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyTypes?.name || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyEndDate
                          ? moment(property?.propertyEndDate).format("LLL")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
        {allDetailsById?.length > 0 ? (
          <Pagination
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            module={allDetailsById}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Card className="cards">
          <Loader isLoad={isLoading} />
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Actions</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Property Id</TableCell>
                  <TableCell>Reference No.</TableCell>
                  <TableCell>Permit Number</TableCell>
                  <TableCell>Badges</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Quality Score</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Property Status</TableCell>
                  <TableCell>Company Name</TableCell>
                  <TableCell>Property Type</TableCell>
                  <TableCell>Expiry Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allDetailsById.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No property found
                    </TableCell>
                  </TableRow>
                ) : (
                  allDetailsById.map((property: any, index: number) => (
                    <TableRow key={property?._id}>
                      <TableCell align="center">
                        {" "}
                        {(page - 1) * 10 + index + 1}
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton
                            onClick={() =>
                              navigate(
                                `/manage-agents/property-listing/details/${property?._id}/${_id}`
                              )
                            }
                          >
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(property?._id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <figure className="user_img">
                          <img
                            style={{ borderRadius: 0 }}
                            src={
                              property?.images?.[0] ||
                              "/static/images/product1.png"
                            }
                            alt=""
                          />
                        </figure>
                      </TableCell>
                      <TableCell>{property?.referenceId || "-"}</TableCell>
                      <TableCell>
                        {property?.import_reference_number || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.advertisementPermitNo || "-"}
                      </TableCell>

                      <TableCell align="center">
                        <figure className="user_img">
                          {property?.properties?.isVerified ? (
                            <img
                              className="property_badge"
                              src="/static/images/verfy_icon.svg"
                              alt=""
                            />
                          ) : (
                            ""
                          )}
                          {property?.properties?.qualityScore >= 80 ? (
                            <img src="/static/images/verify_ico.svg" alt="" />
                          ) : (
                            ""
                          )}
                          {property?.properties?.isPropertyBoost ? (
                            <img src="/static/images/boost.png" alt="" />
                          ) : (
                            ""
                          )}
                        </figure>
                      </TableCell>
                      <TableCell>{property?.name || "-"}</TableCell>
                      <TableCell>
                        {property?.price
                          ? formatNumberWithCommas(property?.price)
                          : "-"}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (property?.qualityScoreMeetCriteria?.length) {
                            setQualityScoreData({
                              complete:
                                property?.qualityScoreMeetCriteria || [],
                              incomplete:
                                property?.qualityScorePendingCriteria || [],
                            });
                            setOpenCriteria(true);
                          }
                        }}
                      >
                        {property?.qualityScore || "-"}
                      </TableCell>
                      <TableCell>{property?.address || "-"}</TableCell>
                      <TableCell>
                        {property?.isClaimDocStatus === 1
                          ? "Pending"
                          : property?.isClaimDocStatus === 2
                            ? "Approved"
                            : "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyStatus === 1
                          ? "Rented"
                          : property?.propertyStatus === 2
                            ? "Sold"
                            : "Live"}
                      </TableCell>

                      <TableCell>
                        {property?.companyId?.companyName
                          ? property?.companyId?.companyName +
                            " (" +
                            property?.companyId?.referenceId +
                            ")"
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyTypes?.name || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyEndDate
                          ? moment(property?.propertyEndDate).format("LLL")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
        {allDetailsById?.length > 0 ? (
          <Pagination
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            module={allDetailsById}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Card className="cards">
          <Loader isLoad={isLoading} />
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Actions</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Property Id</TableCell>
                  <TableCell>Reference No.</TableCell>
                  <TableCell>Permit Number</TableCell>
                  <TableCell>Badges</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Quality Score</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Property Status</TableCell>
                  <TableCell>Company Name</TableCell>
                  <TableCell>Property Type</TableCell>
                  <TableCell>Expiry Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allDetailsById.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No property found
                    </TableCell>
                  </TableRow>
                ) : (
                  allDetailsById.map((property: any, index: number) => (
                    <TableRow key={property?._id}>
                      <TableCell align="center">
                        {" "}
                        {(page - 1) * 10 + index + 1}
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton
                            onClick={() =>
                              navigate(
                                `/manage-agents/property-listing/details/${property?._id}/${_id}`
                              )
                            }
                          >
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(property?._id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <figure className="user_img">
                          <img
                            style={{ borderRadius: 0 }}
                            src={
                              property?.images?.[0] ||
                              "/static/images/product1.png"
                            }
                            alt=""
                          />
                        </figure>
                      </TableCell>
                      <TableCell>{property?.referenceId || "-"}</TableCell>
                      <TableCell>
                        {property?.import_reference_number || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.advertisementPermitNo || "-"}
                      </TableCell>

                      <TableCell align="center">
                        <figure className="user_img">
                          {property?.properties?.isVerified ? (
                            <img
                              className="property_badge"
                              src="/static/images/verfy_icon.svg"
                              alt=""
                            />
                          ) : (
                            ""
                          )}
                          {property?.properties?.qualityScore >= 80 ? (
                            <img src="/static/images/verify_ico.svg" alt="" />
                          ) : (
                            ""
                          )}
                          {property?.properties?.isPropertyBoost ? (
                            <img src="/static/images/boost.png" alt="" />
                          ) : (
                            ""
                          )}
                        </figure>
                      </TableCell>
                      <TableCell>{property?.name || "-"}</TableCell>
                      <TableCell>
                        {property?.price
                          ? formatNumberWithCommas(property?.price)
                          : "-"}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (property?.qualityScoreMeetCriteria?.length) {
                            setQualityScoreData({
                              complete:
                                property?.qualityScoreMeetCriteria || [],
                              incomplete:
                                property?.qualityScorePendingCriteria || [],
                            });
                            setOpenCriteria(true);
                          }
                        }}
                      >
                        {property?.qualityScore || "-"}
                      </TableCell>
                      <TableCell>{property?.address || "-"}</TableCell>
                      <TableCell>
                        {property?.propertyStatus === 1
                          ? "Rented"
                          : property?.propertyStatus === 2
                            ? "Sold"
                            : "Live"}
                      </TableCell>

                      <TableCell>
                        {property?.companyId?.companyName
                          ? property?.companyId?.companyName +
                            " (" +
                            property?.companyId?.referenceId +
                            ")"
                          : "-"}
                      </TableCell>

                      <TableCell>
                        {property?.propertyTypes?.name || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyEndDate
                          ? moment(property?.propertyEndDate).format("LLL")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
        {allDetailsById?.length > 0 ? (
          <Pagination
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            module={allDetailsById}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <Card className="cards">
          <Loader isLoad={isLoading} />
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Actions</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Property Id</TableCell>
                  <TableCell>Reference No.</TableCell>
                  <TableCell>Permit Number</TableCell>
                  <TableCell>Badges</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Quality Score</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Property Status</TableCell>
                  <TableCell>Agent Name</TableCell>
                  <TableCell>Property Type</TableCell>
                  <TableCell>Expiry Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allDetailsById.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No property found
                    </TableCell>
                  </TableRow>
                ) : (
                  allDetailsById.map((property: any, index: number) => (
                    <TableRow key={property?._id}>
                      <TableCell align="center">
                        {" "}
                        {(page - 1) * 10 + index + 1}
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton
                            onClick={() =>
                              navigate(
                                `/manage-agents/property-listing/details/${property?._id}/${_id}`
                              )
                            }
                          >
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(property?._id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <figure className="user_img">
                          <img
                            style={{ borderRadius: 0 }}
                            src={
                              property?.images?.[0]
                                ? property?.images?.[0]
                                : property?.interior?.[0]
                                  ? property?.interior?.[0]
                                  : `/static/images/product1.png`
                            }
                            alt=""
                          />
                        </figure>
                      </TableCell>
                      <TableCell>{property?.referenceId || "-"}</TableCell>
                      <TableCell>
                        {property?.import_reference_number || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.advertisementPermitNo || "-"}
                      </TableCell>

                      <TableCell align="center">
                        <figure className="user_img">
                          {property?.isVerified ? (
                            <img
                              className="property_badge"
                              src="/static/images/verfy_icon.svg"
                              alt=""
                            />
                          ) : (
                            ""
                          )}
                          {property?.qualityScore >= 80 ? (
                            <img src="/static/images/verify_ico.svg" alt="" />
                          ) : (
                            ""
                          )}
                          {property?.isPropertyBoost ? (
                            <img src="/static/images/boost.png" alt="" />
                          ) : (
                            ""
                          )}
                        </figure>
                      </TableCell>
                      <TableCell>{property?.name || "-"}</TableCell>
                      <TableCell>
                        {property?.price
                          ? formatNumberWithCommas(property?.price)
                          : "-"}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (property?.qualityScoreMeetCriteria?.length) {
                            setQualityScoreData({
                              complete:
                                property?.qualityScoreMeetCriteria || [],
                              incomplete:
                                property?.qualityScorePendingCriteria || [],
                            });
                            setOpenCriteria(true);
                          }
                        }}
                      >
                        {property?.qualityScore || "-"}
                      </TableCell>
                      <TableCell>{property?.address || "-"}</TableCell>
                      <TableCell>
                        {property?.propertyStatus === 1
                          ? "Rented"
                          : property?.propertyStatus === 2
                            ? "Sold"
                            : "Live"}
                      </TableCell>

                      <TableCell>
                        {property?.userId?.role === ROLE.AGENCY ||
                        !property?.userId?.role
                          ? "-"
                          : property?.userId?.name +
                              " (" +
                              property?.userId?.referenceId +
                              ")" || "-"}
                      </TableCell>

                      <TableCell>
                        {property?.propertyTypes?.name || "-"}
                      </TableCell>
                      <TableCell>
                        {property?.propertyEndDate
                          ? moment(property?.propertyEndDate).format("LLL")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
        {allDetailsById?.length > 0 ? (
          <Pagination
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            module={allDetailsById}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </CustomTabPanel>

      <QualityCriteria
        open={openCriteria}
        setOpen={setOpenCriteria}
        onClose={onCloseCriteria}
        data={qualityScoreData}
      />

      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteProperty(selectedId)}
        name="Property"
      />
    </>
  );
};

export default AgentPropertiesDetails;
